module.exports = __webpack_public_path__ + "static/background-1-1157fe8a99d139e9aad91d06cd5628a9.svg";